import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import projects_data from './Projects.json';
import ProjectCard from './ProjectCard';
import './Projects.css';

const Projects = () => {
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const visibleProjects = showAll ? projects_data : projects_data.slice(0, 6);

  return (
    <section id="projects" className="projects-section">
      <div className="container">
        <div className="project-header" data-aos="fade-up">
          <p>P R O J E C T S</p>
          <h3>Things that I have built</h3>
        </div>
        <div className="projects-grid">
          {visibleProjects?.map((project, index) => (
            <ProjectCard
              key={project.id}
              info={project}
              delay={(index + 1) * 100}
            />
          ))}
        </div>

        {projects_data.length > 6 && (
          <div
            className="show-more-container"
            data-aos="fade-up"
            data-aos-delay={visibleProjects.length * 100}
            data-aos-once="true"
          >
            <button onClick={() => setShowAll(!showAll)} className="show-more-btn">
              {showAll ? 'Show less' : 'Show more'}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Projects;
